import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import App from './app/App';
import './styles/main.scss';
import UserContextProvider from './context/UserContext';
import LanguageProvider from './context/LanguageContext';
import themeConfig from './theme/themeConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ConfigProvider theme={themeConfig}>
            <LanguageProvider>
                <UserContextProvider>
                    <App />
                </UserContextProvider>
            </LanguageProvider>
        </ConfigProvider>
    </BrowserRouter>,
);
